// extracted by mini-css-extract-plugin
export default {"MetricsFallback":"MetricsFallbackyZFjv6-5re2L"};